<template>
  <div>
    <div class="mx-auto bg-white flex items-center gap-3 px-4 py-3">
      <div class="circle-img">
        <img :src="get_user_image()" style="width: 100%;"/>
      </div>
      <div class="user-info">
        <div class="text-sm">{{ user_name }}</div>
        <div v-if="user_mobile" class="text-xs">{{ user_mobile }}</div>
      </div>
      <div class="flex-grow"></div>
      <div class="border border-gray-500 rounded-md py-1 px-2 " v-if="branch_name">
        <div class="text-sm">{{ branch_name }}</div>
      </div>
    </div>


    

    <div class="pb-20 overflow-auto h-full">
            <div v-if="$i18n.locale=='fa'" class="grid grid-cols-2 gap-4 px-4">
              <div v-if="accept_add_request" class="flex justify-center" v-on:click="go_to_customer_info(false)">
                <img class="w-full" src="../../../public/img/sabt_dar_shobe.png"/>
              </div>
              <div v-if="accept_add_request" class="flex justify-center" v-on:click="go_to_customer_info(true)">
                <img class="w-full" src="../../../public/img/sabt_dar_mahal.png"/>
              </div>
              <div class="flex justify-center relative" v-on:click="go_to_referred_requests">
                <img class="w-full" src="../../../public/img/my_refers.png"/>
                <!-- Badge برای نمایش تعداد -->
                <span v-if="referCount > 0" class="absolute top-0 right-0 z-10 bg-red-600 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center transform translate-x-1/2 -translate-y-1/2 shadow" style="background-color: #ff1616;">
                  {{ referCount > 99 ? '۹۹+' : String(referCount).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d]) }}
                </span>
              </div>
              <div class="flex justify-center">
                <img class="w-full" src="../../../public/img/shekaiat_logo.png"/>
              </div>
              <div v-if="accept_device" class="flex justify-center" v-on:click="go_to_safir_devices()">
                <img class="w-full" src="../../../public/img/safir_logo.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_report_referred_requests">
                <img class="w-full" src="../../../public/img/report_refered_request.png"/>
              </div>
              <div v-if="accept_all_request" class="flex justify-center" v-on:click="go_to_search_all_requests">
                <img class="w-full" src="/img/AllRequests.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_product_requests">
                <img class="w-full" src="/img/product_request.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_buy_orders">
                <img class="w-full" src="/img/buy_orders.png"/>
              </div>
              <div v-if="accounting_report" class="flex justify-center" v-on:click="go_to_accounting_report">
                <img class="w-full" src="/img/AccountingReport.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_morakhasi">
                <img class="w-full" src="/img/morakhasi.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_pay_report">
                <img class="w-full" src="/img/request_accounting_report.png"/>
              </div>
            </div>

            <div v-if="$i18n.locale=='en'" class="grid grid-cols-2 gap-4 px-4">
              <div v-if="accept_add_request" class="flex justify-center" v-on:click="go_to_customer_info(false)">
                <img class="w-full" src="/img/sabt_dar_shobe_tr.png"/>
              </div>
              <div v-if="accept_add_request" class="flex justify-center" v-on:click="go_to_customer_info(true)">
                <img class="w-full" src="/img/sabt_dar_mahal_tr.png"/>
              </div>
              <div class="flex justify-center relative" v-on:click="go_to_referred_requests">
                <img class="w-full" src="/img/my_refers_tr.png"/>
                <!-- Badge برای نمایش تعداد -->
                <span v-if="referCount > 0" class="absolute top-0 right-0 z-10 bg-red-600 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center transform translate-x-1/2 -translate-y-1/2 shadow" style="background-color: #ff1616;">
                  {{ referCount > 99 ? '۹۹+' : String(referCount).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d]) }}
                </span>
              </div>
              <div class="flex justify-center">
                <img class="w-full" src="/img/shekaiat_logo_tr.png"/>
              </div>
              <div v-if="accept_device" class="flex justify-center" v-on:click="go_to_safir_devices()">
                <img class="w-full" src="/img/safir_logo_tr.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_report_referred_requests">
                <img class="w-full" src="/img/report_refered_request_tr.png"/>
              </div>
              <div v-if="accept_all_request" class="flex justify-center" v-on:click="go_to_search_all_requests">
                <img class="w-full" src="/img/AllRequests_tr.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_product_requests">
                <img class="w-full" src="/img/product_request_tr.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_buy_orders">
                <img class="w-full" src="/img/buy_orders_tr.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_accounting_report">
                <img class="w-full" src="/img/AccountingReport.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_morakhasi">
                <img class="w-full" src="/img/morakhasi.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_pay_report">
                <img class="w-full" src="/img/request_accounting_report.png"/>
              </div>
            </div>
    </div>
      <BottomNav v-model="tab">
      </BottomNav>

    <div class="start-conversation" v-on:click="goToReminder()">
      <img src="/img/svg/reminder.svg" alt="reminder" class="w-7 h-7">
    </div>
  </div>

</template>
<script>
  import {bus} from '../../main.js'
  import BottomNav from '../../components/BottomNav.vue'

  export default {
    components: { BottomNav },
    data() {
      return {
        tab: null,
        branch_name:localStorage.getItem("branch_name"),
        user_name: (JSON.parse(localStorage.getItem('profile')) || {}).UserName || '',
        user_mobile: (localStorage.getItem('phone') || '').replace('+98',''),
        app_version: process.env.VUE_APP_VERSION_CODE,
        accept_device: false,
        accept_add_request: false,
        accept_all_request: false,
        accounting_report: false,
        referCount: 0, // تعداد درخواست‌های ارجاعی
      }
    },
    mounted() {
      this.config_firebase();
      this.check_accept_device()
      this.check_ZkCheckManageReport()
      this.check_add_request()
      this.check_all_request()
      this.technician_login()
      this.check_user_in_zoodkomak()
      Notification.requestPermission(permission => {
        if (permission === 'granted') {
          this.registerBackgroundSync()
        } else console.error("Permission was not granted.")
      })
    },
    methods: {
      registerBackgroundSync() {
        if (!navigator.serviceWorker) {
          return console.error("Service Worker not supported")
        }

        navigator.serviceWorker.ready
          .then(registration => registration.sync.register('syncAttendees'))
          .then(() => console.log("Registered background sync"))
          .catch(err => console.error("Error registering background sync", err))
      },
      goToReminder() {
        this.$router.push({name: 'ReminderList', params: {}})
      },
      config_firebase() {
        // var self = this;
        // try{
        //   this.$messaging.messaging.requestPermission().then(() => {
        //     console.log('Notification permission granted.');
        //
        //     // Get Token
        //     this.$messaging.db.app.messaging().getToken({vapidKey: "BP9_Qg8FqhjCVuttOnqcBmKnfE1Eu9m22xNb4dy8DEWKG90lDXN--n-ZCIoYgImZLe4oAGb-Iej0CD9rdvdzr-M"})
        //       .then((currentToken) => {
        //         if (currentToken) {
        //           console.log('client token', currentToken)
        //           self.send_token(currentToken);
        //           self.$messaging.messaging.onMessage((payload) => {
        //             console.log('Message received. ', payload);
        //             // ...
        //           });
        //           self.$messaging.db.app.messaging().onMessage((payload) => {
        //             console.log('Message received2. ', payload);
        //             // ...
        //           });
        //
        //         } else {
        //           console.log('No registration token available. Request permission to generate one.');
        //         }
        //       }).catch((err) => {
        //       console.log('An error occurred while retrieving token. ', err);
        //     })
        //   }).catch((err) => {
        //     console.log('Unable to get permission to notify.', err);
        //   });
        //
        // }catch (e) {
        //   console.log('error Request permission to generate one.',e);
        //
        // }
      },
      send_token(token) {
        console.log(localStorage.getItem('profile'))
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var device_id = JSON.parse(localStorage.getItem('profile')).UserDeviceNo

        const send_data = {
          UserId: user_id,
          DeviceId: device_id,
          Token: token,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/UpdateFirebaseToken', send_data, {show_pros: false})
          .then(response => {
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      check_user_in_zoodkomak() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var user_name = JSON.parse(localStorage.getItem('profile')).UserName

        const send_data = {
          MobileNo: localStorage.getItem("phone").replace("+98", ""),
          Pass: localStorage.getItem("password"),
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://panel.zoodkomak.com/jetToken/GetToken', send_data, {show_pros: false})
          .then(response => {
            localStorage.setItem('userId2', response.data.UserId)
            if (response.data && response.data.ImageUrl) {
              localStorage.setItem('ImageUrl', response.data.ImageUrl)
            }
            // ذخیره تعداد درخواست‌های ارجاعی
            if (response.data && response.data.ReferCount !== undefined) {
              self.referCount = parseInt(response.data.ReferCount) || 0
            }

            // const send_data = {
            //   UserName: user_name,
            //   UserId: response.data.UserId,
            //   MobileNo: localStorage.getItem("phone"),
            //   Password: localStorage.getItem("password"),
            // }
            var formData = new FormData();
            formData.append('UserName',user_name);
            formData.append('UserId',response.data.UserId);
            formData.append('MobileNo',localStorage.getItem("phone"));
            formData.append('Password',localStorage.getItem("password"));

            // this.axios.post('/Register' , send_data,{
            self.axios.post('https://cp.zoodkomak.com/api/check_user_in_zoodkomak', formData, {show_pros: false})
              .then(response => {
                // this.$router.push({ path: "/post-login", params: {} });
              }).catch(e => {
              this.errors.push(e)
            })

          }).catch(e => {
          this.errors.push(e)
        })
      },
      go_to_customer_info(OnSite) {
        var PassingData = {on_site_service: OnSite}
        localStorage.setItem('request_data', JSON.stringify(PassingData))
        // this.$store.commit('set', ['request_data', PassingData])
        // this.$store.commit('toggleSidebarDesktop')
        // console.log(store.state.count) //
        this.$router.push({name: 'CustomerInfo', params: {}})
      },
      go_to_referred_requests() {
        this.$router.push({name: 'ReferredRequest', params: {}})
      },
      go_to_morakhasi() {
        this.$router.push({name: 'MorakhasiList', params: {}})
      },
      go_to_pay_report() {
        this.$router.push({name: 'RequestPayReportList', params: {}})
      },
      go_to_buy_orders() {
        this.$router.push({name: 'BuyOrdersList', params: {}})
      },
      go_to_report_referred_requests() {
        this.$router.push({name: 'ReportReferredRequest', params: {}})
      },
      go_to_search_all_requests() {
        this.$router.push({path: '/report-request/search-all-requests', params: {}})
      },
      go_to_safir_devices() {
        this.$router.push({name: 'SafirDevices', params: {}})
      },
      go_to_product_requests() {

        this.$router.push({name: 'ProductRequestFactors', params: {rec_id: 0}})
      },
      go_to_accounting_report() {

        this.$router.push({name: 'AccountingReport', params: {}})
      },
      check_accept_device() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          PartyId: party_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/CheckAcceptDevice', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.accept_device = true
            } else {
              self.accept_device = false
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      check_ZkCheckManageReport() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          PartyId: party_id,
          Role: "CheckManageReport",
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ZkGetUserPermission', send_data, {})
          .then(response => {
            if (response.data.UserAllow) {
              self.accounting_report = true
            } else {
              self.accounting_report = false
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      check_add_request() {
        console.log(localStorage.getItem('profile'))
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          PartyId: party_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/CheckCustomerRequest', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.accept_add_request = true
            } else {
              self.accept_add_request = false
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      check_all_request() {
        console.log(localStorage.getItem('profile'))
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          PartyId: party_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/CheckSysAllReqs', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.accept_all_request = true
            } else {
              self.accept_all_request = false
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      technician_login() {
        var self = this
        var eddited_mobile = localStorage.getItem('phone')
        var password = localStorage.getItem('password')

        const send_data = {
          MobileNo: eddited_mobile,
          Password: password,
          "OsName": "PWA",
          "AppNo": "4",
          "OsVersion": "1",
          DeviceModel: 'android',
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/TechnicianLogin', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              localStorage.setItem("PrivateCall", response.data.newVersion.PrivateCall);

              console.log('version is ', self.app_version, response.data.newVersion.VersionCode)
              if (self.app_version < response.data.newVersion.VersionCode) {
                if ('serviceWorker' in navigator) {
                  caches.keys().then(function (cacheNames) {
                    cacheNames.forEach(function (cacheName) {
                      caches.delete(cacheName);
                    });
                  });
                }
                window.location.reload(true)

              }
            } else {
              localStorage.setItem('profile', '')
              localStorage.setItem('phone', '')
              localStorage.setItem('password', '')
              localStorage.setItem('party_id', '')
              self.$router.push({name: 'login', params: {}})

              bus.$emit('show_toast', [2000, response.data.msg])
            }
          }).catch(e => {
          // this.errors.push(e);
          // bus.$emit('show_toast', [2000, e])

        })
      },

    }
  }
</script>
<style scoped>
  /* .modern-nav-tabs {
    background: rgba(255, 255, 255, 0.55) !important;
    -webkit-backdrop-filter: saturate(140%) blur(14px) !important;
    backdrop-filter: saturate(140%) blur(14px) !important;
    border-top: 1px solid rgba(15, 23, 42, 0.08) !important;
    box-shadow: rgba(0, 0, 0, 0.14) 0px -1px 12px !important;
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1000 !important;
  } */

  .nav-tab {
    flex: 1 !important;
    min-width: 0 !important;
    padding: 8px 4px !important;
    background: transparent !important;
  }

  .nav-tab-content {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 8px 0 !important;
  }

  .nav-icon {
    color: #94a3b8 !important; /* gray default */
    transition: all 0.3s ease !important;
    border-radius: 12px !important;
    padding: 8px !important;
  }

  /* Default color for inline SVG icons inside tabs */
  .nav-tab .nav-tab-content svg {
    color: #94a3b8 !important; /* sets currentColor */
  }
  /* Make common SVG shapes follow currentColor and stay outline */
  .nav-tab .nav-tab-content svg path,
  .nav-tab .nav-tab-content svg circle,
  .nav-tab .nav-tab-content svg rect,
  .nav-tab .nav-tab-content svg line,
  .nav-tab .nav-tab-content svg polyline,
  .nav-tab .nav-tab-content svg polygon {
    stroke: currentColor !important;
    fill: none !important;
  }


  /* Active state */
  .nav-tab.v-tab--active .nav-icon {
    color: #1c39bb !important; /* blue active */
    background: rgba(255, 255, 255, 0.15) !important; /* glass */
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(28, 57, 187, 0.25) !important;
    box-shadow: 0 6px 18px rgba(28, 57, 187, 0.18) !important;
  }

  /* Active state for inline SVG icons */
  .nav-tab.v-tab--active .nav-tab-content svg {
    color: #1c39bb !important;
  }


  /* Hover state */
  .nav-tab:hover .nav-icon {
    color: #1c39bb !important;
    background: rgba(255, 255, 255, 0.1) !important;
    backdrop-filter: blur(6px) !important;
    border: 1px solid rgba(28, 57, 187, 0.2) !important;
    transform: translateY(-2px) !important;
  }


  /* Remove default Vuetify tab styling */
  ::v-deep .v-tabs-bar {
    background: transparent !important;
  }

  ::v-deep .v-tab {
    text-transform: none !important;
    font-weight: normal !important;
  }

  ::v-deep .v-tabs-slider {
    display: none !important;
  }
</style>
